// extracted by mini-css-extract-plugin
export default {"root":"AuditorsTableBulkOperations_root__RRQ9P"};